import React, { useContext, useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import Context from '../../../container';
import Helmet from '../../../components/Helmet';
import '../../../components/AIP/aip-banner-wrap.scss';
import { AIP_SOLUTION_SEO_TDK, type AipSolutionSeoKey } from '../seo-tdk';
import Procurement from './details/Procurement';
import ProcurementandSales from './details/ProcurementandSales';
import SupplyChainPlanning from './details/SupplyChainPlanning';

type SolutionName = 'supply-chain-planning' | 'procurement-and-sales' | 'procurement';

const SOLUTION_COMPONENTS: Record<SolutionName, React.ComponentType<any>> = {
  'supply-chain-planning': SupplyChainPlanning,
  'procurement-and-sales': ProcurementandSales,
  procurement: Procurement
};

export default function AipSolutionEntry(props: any) {
  const { dispatch } = useContext(Context);
  const { solutionName } = useParams<{ solutionName?: string }>();

  useEffect(() => {
    dispatch({ theme: 'dark' });
    return () => {
      dispatch({ theme: undefined });
    };
  }, [dispatch]);

  if (!solutionName) return <Redirect to="/solution" />;

  const Component = (SOLUTION_COMPONENTS as Record<string, React.ComponentType<any>>)[solutionName];
  if (!Component) return <Redirect to="/solution" />;

  const seo =
    solutionName && solutionName in AIP_SOLUTION_SEO_TDK
      ? AIP_SOLUTION_SEO_TDK[solutionName as AipSolutionSeoKey]
      : undefined;

  return (
    <>
      {seo ? <Helmet title={seo.title} description={seo.description} keywords={seo.keywords} /> : null}
      <Component {...props} />
    </>
  );
}

